import React from "react"
import { FeaturedSection, Icon } from "../.."
import { Container, Heading, Button, Text } from "@chakra-ui/react"
import { handleMenuLinkClick } from "../../../handlers"
import { Link } from "gatsby"

export default function Cta() {
  return (
    <FeaturedSection>
      <Container>
        <Heading fontWeight="semibold" fontSize={"3xl"} align="center" as="h2">
          Have a query?
        </Heading>
        <Heading
          color="primary.200"
          fontSize="lg"
          textAlign="center"
          fontWeight="medium"
        >
          Let us help you
        </Heading>
        <Button
          as={Link}
          to={"/#contact"}
          onClick={event => handleMenuLinkClick("/#contact", event)}
          variant="primary"
          alignSelf="center"
          size="lg"
          mt={8}
        >
          <Text as="span" lineHeight={1} fontWeight="bold">
            Get in touch
          </Text>
          <Icon name="email" boxSize={6} ml={3} />
        </Button>
      </Container>
    </FeaturedSection>
  )
}
